import {Fragment, h} from "preact";
import s from "./textArea.module.css";

/**
 * A simple textarea component that can be used globally in the application.
 * Provides error messages support through the `error` property.
 * */
const TextArea = props => {
    // Destructured component props
    const {
        type,
        label,
        name,
        handleChange,
        placeholder,
        value,
        error =             undefined,
        isRequired =         false,
        fieldsetClassName = undefined,
        labelClassName =    undefined,
        className =         undefined,
        dataTestId =             null,
        subLabel =          undefined,
        omitErrorMessage =   true,
        // Any additional data that must be passed to the handler
        additionalData =              undefined,
        ...rest
    } = props;

    // The variable name says it all
    const errorMessage = !omitErrorMessage && error && (
        <p className={`${s.errorMessage}`}>
            {error}
        </p>
    );

    return (
        <Fragment>
            <fieldset className={`w-full flex flex-col justify-end gap-y-1 ${fieldsetClassName}`}>
                <label
                    htmlFor={`${name}-input`}
                    className={`${s.label} ${labelClassName}`}
                    data-testid="generic-input-label"
                >
                    {label}&nbsp;
                    <span
                        className={`${!isRequired ? "hidden" : ""} text-sabin-red-default`}
                        data-testid="generic-input-required-label"
                    >
                        *
                    </span>
                    <span
                        className={`${!subLabel ? "hidden" : ""}`}
                        data-testid="generic-input-required-label"
                    >
                        &nbsp;&nbsp;{subLabel}
                    </span>
                </label>
                <div className={"relative w-full"}>
                    <textarea
                        // type={type}
                        className={`
                            ${s.input} 
                            ${error
                            ? ` ${s.isInvalid}` 
                                : (!error && value) ? ` ${s.isValid}` : ""
                            } 
                            ${className}`
                        }
                        placeholder={placeholder}
                        id={`${name}-input`}
                        name={name}
                        onInput={e => handleChange(e, additionalData)}
                        value={value}
                        {...rest}
                        data-testid={dataTestId || 'generic-input'}
                    />
                </div>
                {errorMessage}
            </fieldset>
        </Fragment>
    )
}

export default TextArea;
